import actionTypes from '../webActionTypes';
import GLOBAL from '../../jcolorglobal';

const API_URL = '/InvoicePrizeAdminAction.do';

function beginCheckPrizedInvoice(payload) {
    return { type: actionTypes.beginCheckPrizedInvoice, payload };
}

function recvCheckPrizedInvoiceError(payload) {
    return { type: actionTypes.recvCheckPrizedInvoiceError, payload };
}


function recvCheckPrizedInvoiceResult(payload) {
    return { type: actionTypes.recvCheckPrizedInvoiceResult, payload };
}


function checkPrizedInvoice(payload = {}) {
    return dispatch => {

        dispatch(beginCheckPrizedInvoice(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'checkPrize');
            formData.append('prizelistfile', payload.upldfile);
            

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(recvCheckPrizedInvoiceResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvCheckPrizedInvoiceError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvCheckPrizedInvoiceError(error));
                    reject(error);
                });
        });

        return promise;

    };
}


function beginGetPrizedInvoiceList(payload) {
    return { type: actionTypes.beginGetPrizedInvoiceList, payload };
}

function recvGetPrizedInvoiceListError(payload) {
    return { type: actionTypes.recvGetPrizedInvoiceListError, payload };
}


function recvGetPrizedInvoiceListResult(payload) {
    return { type: actionTypes.recvGetPrizedInvoiceListResult, payload };
}


function getPrizedInvoiceList(payload = {}) {
    return (dispatch, getState) => {
        dispatch(beginGetPrizedInvoiceList(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            const start = payload.start || 0;
            var querykey = '';
            formData.append('op', 'listPrizeInvoices');

            if(payload.yearmonth) {
                formData.append('yearmonth', payload.yearmonth);
                querykey += payload.yearmonth;
            }

            if(payload.hasNoRecord) {
                formData.append('hasNoRecord', payload.hasNoRecord);
                querykey += payload.hasNoRecord;
            }            

            formData.append('start', start || 0);
            formData.append('len', getState().prizedInvoice.pageLen || 20);

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            // 拆解list result成id list and data map兩組資料
                            let ids = {};
                            let data = {};
                            // eslint-disable-next-line
                            result.list.map((listitem, index) => {
                                const id = listitem.istarttag+listitem.invoicenumber;
                                ids[start+index] = id;
                                data[id] = listitem;

                            });
                            const { totalCount } = result;

                            dispatch(recvGetPrizedInvoiceListResult({ids, data, start, totalCount, querykey}));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvGetPrizedInvoiceListError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvGetPrizedInvoiceListError(error));
                    reject(error);
                });
        });

        return promise;

    };
}

function getInvoicePrizeYearmonthList() {
    return (dispatch, getState) => {

        const promise = new Promise((resolve, reject) => {

            const url = API_URL + '?op=getInvoicePrizeYearmonthList';

            GLOBAL.fetchWithCookies(url, {
                method: 'GET',
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    dispatch(finishGetInvoicePrizeYearmonthList(result));
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                reject(error);
            });
        });

        return promise;
    };
}

function finishGetInvoicePrizeYearmonthList(yearmonthList) {

    return { type: actionTypes.finishGetInvoicePrizeYearmonthList, payload: { yearmonthList: yearmonthList } };
}

const PrizedInvoiceActions = {
    beginCheckPrizedInvoice,
    recvCheckPrizedInvoiceError,
    recvCheckPrizedInvoiceResult,
    checkPrizedInvoice,
    beginGetPrizedInvoiceList,
    recvGetPrizedInvoiceListError,
    recvGetPrizedInvoiceListResult,
    getPrizedInvoiceList,
    getInvoicePrizeYearmonthList,
};

export default PrizedInvoiceActions;


// WEBPACK FOOTER //
// ./src/actions/creators/prizedInvoiceActions.js